import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VCalendar from 'v-calendar'
import print from 'vue3-print-nb'
import vue3GoogleLogin from 'vue3-google-login'


import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"




import i18n from './i18n'

createApp(App).use(vue3GoogleLogin, { clientId: '959641013461-aa2o8a3bcun35kmiqjfqnlkcfhqujduq.apps.googleusercontent.com' }).use(VCalendar, {}).use(i18n).use(router).use(VueAxios, axios).use(print).mount('#app')
